"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyRewardsTasksDto = void 0;
const AppVersionDto_1 = require("../app-versions/AppVersionDto");
const LocationDto_1 = require("../locations/LocationDto");
class LoyaltyRewardsTasksDto {
    constructor(params) {
        this.title = "";
        this.description = "";
        this.imageUrl = "";
        this.qrCodeValue = "";
        this.canOnlyRedeemOnce = false;
        this.expiresAt = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.locationId = params.locationId;
        this.kind = params.kind;
        this.title = params.title;
        this.description = params.description;
        this.imageUrl = params.imageUrl;
        this.points = params.points;
        this.qrCodeValue = params.qrCodeValue;
        this.canOnlyRedeemOnce = params.canOnlyRedeemOnce;
        this.expiresAt = params.expiresAt;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.appVersion !== undefined) {
            this.appVersion = params.appVersion === null ?
                null :
                new AppVersionDto_1.AppVersionDto(params.appVersion);
        }
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
    }
}
exports.LoyaltyRewardsTasksDto = LoyaltyRewardsTasksDto;
//# sourceMappingURL=LoyaltyRewardsTasksDto.js.map